import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotSpectralMask, UpdateSnapshotSpectralMaskDto } from 'types';

export const updateMask = ({
  data,
  snapshotId,
  maskId,
}: {
  data: UpdateSnapshotSpectralMaskDto;
  snapshotId: number;
  maskId: number;
}): Promise<SnapshotSpectralMask> => {
  return axios.put(
    `/api/snapshots/${snapshotId}/spectral-masks/${maskId}`,
    data
  );
};

type UseUpdateSnapshotOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof updateMask>;
};

export const useUpdateMask = ({
  config,
  snapshotId,
}: UseUpdateSnapshotOptions) => {
  return useMutation({
    onMutate: async (updatingMask) => {
      await queryClient.cancelQueries([
        'snapshot',
        snapshotId,
        'masks',
        updatingMask.maskId,
      ]);

      const previousMask = queryClient.getQueryData<SnapshotSpectralMask>([
        'snapshot',
        snapshotId,
        'masks',
        updatingMask.maskId,
      ]);

      queryClient.setQueryData(
        ['snapshot', snapshotId, 'masks', updatingMask.maskId],
        {
          ...previousMask,
          ...updatingMask.data,
          id: updatingMask.maskId,
        }
      );

      return previousMask;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: updateMask,
  });
};
